import React from "react";
import { Link } from "react-router-dom";

function Card({ title, children, price, bg, buy }) {
  return (
    <div className="flex-1 flex justify-center items-center flex-col m-4 p-2 py-4 shadow-md rounded-2xl" style={{minWidth:"250px", background:bg}}>
      <img
        src="/images/conversation.svg"
        className="w-50 mx-auto my-3"
      />
      <h2 className="text-2xl font-bold">{title}</h2>
      <p className="text-xl font-semibold">{children}</p>
      <p className="text-2xl font-bold">{price}</p>
      {buy?<Link className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-2" to={`/payment?package=${title.toLowerCase()}`}>
        Buy Now
      </Link>:<></>}
    </div>
  );
}

function PackageCard({ price, credits, maxPosters }) {
  return (
    <Link to={`/payment?price=${price}`} className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-2 flex flex-col justify-center items-center m-1">
      <span className="text-2xl">₹{price}</span>
      <span className="text-xl">{credits} Credits</span>
      <span className="text-md font-thin">Generate upto {maxPosters} posters*</span>
    </Link>
  );
}

function getMoreCredits(){
  document.getElementById("get-credits").style.display = "none";
  document.getElementById("get-credits-pkgs").style.display = "flex";
}

function Pricing() {
  return (
    <>
      <h1 className="text-4xl pt-4 font-black">Pricing</h1>
      {/* <p className="mt-4">
        Join the 100000000+ people who use this thing to make cool posters
      </p> */}
      {/* <div className="flex w-full p-4 justify-center" id="get-credits">
        <div className="bg-white p-4 shadow-sm rounded-xl flex flex-row justify-center content-center align-middle">
          <h2 className="text-3xl font-bold">Refill Wallet</h2>
          <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded ml-3" onClick={getMoreCredits}>
            Get More Credits
          </button>
        </div>
      </div>
      <div className="flex w-full p-4 justify-center" id="get-credits-pkgs" style={{display:"none"}}>
        <div className="bg-white w-full p-4 shadow-sm rounded-xl flex flex-col justify-center content-center align-middle">
          <h2 className="text-2xl font-bold mb-2">Choose a package</h2>
          <div className="flex flex-row w-full justify-evenly flex-wrap">
            <PackageCard 
              price={160}
              credits={200}
              maxPosters={20}
            />
            <PackageCard 
              price={270}
              credits={350}
              maxPosters={35}
            />
            <PackageCard 
              price={499}
              credits={650}
              maxPosters={65}
            />
            <PackageCard 
              price={999}
              credits={1400}
              maxPosters={140}
            />
          </div>
        </div>
      </div> */}
      <div className="flex w-full p-4 flex-wrap">
        <Card
          title="Bronze"
          price="₹25"
          bg="linear-gradient(-45deg, #D3904D90 45%, #DDA87490 45%, #D89C6090 50%, #DDA87490 55%, #D3904D90 55%)"
          buy={true}
        >
        <br />
          25 Credits
          (5 per poster)
        <br />
        <br />
        </Card>
        <Card
          title="Silver"
          price="₹100"
          bg="linear-gradient(-45deg, #D7D5D1 45%, #F0F0F0 45%, #E7E7E7 50%, #F0F0F0 55%, #D7D5D1 55%)"
          buy={true}
        >
        <br />
            115 Credits
          (5 per poster)
        <br />
        <br />
        </Card>
        <Card
          title="Gold"
          price="₹500"
          bg="linear-gradient(-45deg, #FFE700BB 45%, #FFFF00BB 45%, #FFE700BB 50%, #FFFF00BB 55%, #FFE700BB 55%)"
          buy={true}
        >
          <br />
            625 Credits
          (5 per poster)
        <br />
        <br />
        </Card>
      </div>
    </>
  );
}

export default Pricing;
